<template>
    <div
        v-for="(message, index) in messages"
        class="my-2 flex items-center gap-4 rounded bg-red-500 text-[16px] font-medium leading-tight text-white"
    >
        <div class="p-2">
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 0.875C4.5125 0.875 0.875 4.5125 0.875 9C0.875 13.4875 4.5125 17.125 9 17.125C13.4875 17.125 17.125 13.4875 17.125 9C17.125 4.5125 13.4875 0.875 9 0.875ZM7.56667 6.68333C7.50945 6.62193 7.44045 6.57268 7.36378 6.53852C7.28712 6.50436 7.20435 6.48599 7.12043 6.48451C7.03652 6.48303 6.95316 6.49846 6.87534 6.5299C6.79751 6.56133 6.72682 6.60812 6.66747 6.66747C6.60812 6.72682 6.56133 6.79751 6.5299 6.87534C6.49846 6.95316 6.48303 7.03652 6.48451 7.12043C6.48599 7.20435 6.50436 7.28712 6.53852 7.36378C6.57268 7.44045 6.62193 7.50945 6.68333 7.56667L8.11667 9L6.68333 10.4333C6.62193 10.4906 6.57268 10.5596 6.53852 10.6362C6.50436 10.7129 6.48599 10.7956 6.48451 10.8796C6.48303 10.9635 6.49846 11.0468 6.5299 11.1247C6.56133 11.2025 6.60812 11.2732 6.66747 11.3325C6.72682 11.3919 6.79751 11.4387 6.87534 11.4701C6.95316 11.5015 7.03652 11.517 7.12043 11.5155C7.20435 11.514 7.28712 11.4956 7.36378 11.4615C7.44045 11.4273 7.50945 11.3781 7.56667 11.3167L9 9.88333L10.4333 11.3167C10.4906 11.3781 10.5596 11.4273 10.6362 11.4615C10.7129 11.4956 10.7956 11.514 10.8796 11.5155C10.9635 11.517 11.0468 11.5015 11.1247 11.4701C11.2025 11.4387 11.2732 11.3919 11.3325 11.3325C11.3919 11.2732 11.4387 11.2025 11.4701 11.1247C11.5015 11.0468 11.517 10.9635 11.5155 10.8796C11.514 10.7956 11.4956 10.7129 11.4615 10.6362C11.4273 10.5596 11.3781 10.4906 11.3167 10.4333L9.88333 9L11.3167 7.56667C11.3781 7.50945 11.4273 7.44045 11.4615 7.36378C11.4956 7.28712 11.514 7.20435 11.5155 7.12043C11.517 7.03652 11.5015 6.95316 11.4701 6.87534C11.4387 6.79751 11.3919 6.72682 11.3325 6.66747C11.2732 6.60812 11.2025 6.56133 11.1247 6.5299C11.0468 6.49846 10.9635 6.48303 10.8796 6.48451C10.7956 6.48599 10.7129 6.50436 10.6362 6.53852C10.5596 6.57268 10.4906 6.62193 10.4333 6.68333L9 8.11667L7.56667 6.68333Z"
                    fill="white"
                />
            </svg>
        </div>
        <div class="p-3">
            <span v-html="message"></span>
        </div>
        <div
            class="ml-auto p-2 hover:cursor-pointer"
            @click="closeMessage(index)"
        >
            <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.557783 0.558298C0.674971 0.441256 0.833824 0.375515 0.99945 0.375515C1.16508 0.375515 1.32393 0.441256 1.44112 0.558298L5.99945 5.11663L10.5578 0.558298C10.615 0.496893 10.684 0.447641 10.7607 0.413481C10.8373 0.379321 10.9201 0.360953 11.004 0.359472C11.0879 0.357992 11.1713 0.373429 11.2491 0.404863C11.3269 0.436297 11.3976 0.483084 11.457 0.542433C11.5163 0.601782 11.5631 0.672477 11.5946 0.7503C11.626 0.828124 11.6414 0.911481 11.6399 0.995401C11.6385 1.07932 11.6201 1.16208 11.5859 1.23875C11.5518 1.31541 11.5025 1.38441 11.4411 1.44163L6.88278 5.99997L11.4411 10.5583C11.5025 10.6155 11.5518 10.6845 11.5859 10.7612C11.6201 10.8378 11.6385 10.9206 11.6399 11.0045C11.6414 11.0884 11.626 11.1718 11.5946 11.2496C11.5631 11.3275 11.5163 11.3981 11.457 11.4575C11.3976 11.5168 11.3269 11.5636 11.2491 11.5951C11.1713 11.6265 11.0879 11.6419 11.004 11.6405C10.9201 11.639 10.8373 11.6206 10.7607 11.5864C10.684 11.5523 10.615 11.503 10.5578 11.4416L5.99945 6.8833L1.44112 11.4416C1.32264 11.552 1.16593 11.6121 1.00401 11.6093C0.842097 11.6064 0.687609 11.5408 0.573098 11.4263C0.458588 11.3118 0.392994 11.1573 0.390138 10.9954C0.387281 10.8335 0.447383 10.6768 0.557783 10.5583L5.11612 5.99997L0.557783 1.44163C0.440741 1.32444 0.375 1.16559 0.375 0.999965C0.375 0.83434 0.440741 0.675486 0.557783 0.558298Z"
                    fill="white"
                />
            </svg>
        </div>
    </div>
</template>
<script>
export default {
    name: "FormErrors",
    props: {
        formName: {
            type: String,
            default: "",
        },
        fields: {
            type: [String, Array],
            default: null,
        },
    },
    data() {
        return {
            messages: [],
        };
    },
    methods: {
        closeMessage(index) {
            this.messages.splice(index, 1);
        },
        getFieldErrors() {
            let vm = this;
            let fields = vm.fields;

            if (fields === null) {
                return;
            }

            fields = fields.split(",");

            fields.forEach(function (fieldName) {
                if (vm.$page.props.errors[fieldName]) {
                    vm.messages.push(vm.$page.props.errors[fieldName]);
                }
            });
        },
        getFormErrors() {
            if (this.$page.props.errors[this.formName]) {
                this.messages.push(this.$page.props.errors[this.formName]);
            }

            if (
                this.$page.props.flash.error &&
                this.$page.props.flash.error[this.formName]
            ) {
                this.messages.push(this.$page.props.flash.error[this.formName]);
            }
        },
    },
    mounted() {
        this.getFieldErrors();
        this.getFormErrors();
    },
    watch: {
        "$page.props.errors": {
            handler(newValue, oldValue) {
                this.getFieldErrors();
                this.getFormErrors();
            },
            deep: false,
        },
        "$page.props.flash.error": {
            handler(newValue, oldValue) {
                this.getFieldErrors();
                this.getFormErrors();
            },
            deep: false,
        },
    },
};
</script>
